export default __webpack_public_path__ + "assets/overcast.45e9e87b.svg";